import { Controller } from "@hotwired/stimulus"

// Reveals elements when they scroll into view using IntersectionObserver.
// Elements use data-scroll-reveal attribute for direction: "", "left", "right", "scale".
// Attach once to <body> via data-controller="scroll-reveal" — observes ALL elements on page.
// Supports data-scroll-reveal-delay for staggered animations (value in ms).
export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.scrollRevealDelay || 0
            setTimeout(() => {
              entry.target.classList.add("revealed")
            }, parseInt(delay))
            this.observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    )

    // Observe ALL scroll-reveal elements on the entire page
    document.querySelectorAll("[data-scroll-reveal]").forEach((el) => {
      const rect = el.getBoundingClientRect()
      // Elements already scrolled past (above viewport) — reveal immediately
      if (rect.bottom < 0) {
        el.classList.add("revealed")
      } else {
        this.observer.observe(el)
      }
    })
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }
}
